// RoleList.js
import { useState, useEffect } from "react";
import List from "../../../common/list";
import { TextInput } from "../../../common/fields";
import { Button } from "primereact/button";
import list from "../../integrations/list";

const RoleList = ({
  roles = [],
  totalCount = 0,
  query,
  setQuery,
  fetchRoles,
  selectedRoles,
  setSelectedRoles,
  preSelectedIds = [],
  onSave,
  totalUserCount,
  onCancel,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredRoles, setFilteredRoles] = useState(roles);

  totalUserCount = roles.reduce((sum, role) => sum + (role.userCount || 0), 0);

    
 

  // Update filteredRoles when roles change or search term changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredRoles(roles);
    } else {
      const filtered = roles.filter((r) =>
        r.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredRoles(filtered);
    }
  }, [roles, searchTerm]);

  // Preselect roles (like in edit)
  useEffect(() => {
    if (preSelectedIds?.length) {
      const preselected = roles.filter((r) => preSelectedIds.includes(r.id));
      setSelectedRoles(preselected);
    }
  }, [roles, preSelectedIds, setSelectedRoles]);

  // Debounced search (like UserList example)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (query.search !== searchTerm) {
        setQuery({ ...query, search: searchTerm, pageNo: 1 });
        fetchRoles?.(searchTerm);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTerm, fetchRoles, setQuery, query.search]);

  const handlePageChange = (pageData) => {
    if (query.pageSize !== pageData.rows || query.pageNo !== pageData.page + 1) {
      setQuery({ ...query, pageNo: pageData.page + 1, pageSize: pageData.rows });
    }
  };


  return (
    <div>
      <div className="edexlms-search-filter-bar mb-4 flex">
        <TextInput
          icon="pi pi-search"
          placeholder="Search roles"
          input={{ value: searchTerm, onChange: (e) => setSearchTerm(e.target.value) }}
        />
      </div>

      <List
        data={filteredRoles}
        totalRecords={totalCount}
        pageQuery={query}
        handlePageChange={handlePageChange}
        selectionMode="checkbox"
        selectedRecords={selectedRoles}
        onSelectionChange={(e) =>{
          setSelectedRoles(e.value)
        }}
        columns={[
          {
            field: "name",
            header: "Name",
            body: (rowData) => <div>{rowData.name}</div>,
          },
          {
            field: "userCount",
            header: "User Count",
            body: (rowData) => <div>{rowData.name === "Learner" ? totalUserCount : rowData.userCount ?? 0}</div>,
          },
        ]}
      />

      <div className="flex justify-end mt-4 gap-2">
        <Button label="Cancel" onClick={()=>{onCancel()}} className="p-button-text" />
        <Button label="Save" onClick={() => onSave(selectedRoles)} />
      </div>
    </div>
  );
};

export default RoleList;
